import { PROFILE_VERSION } from "./playerProfileConstants";

/**
 * Fields to add when an older player has no profile shell.
 * Never replaces a name or sex the player already saved.
 * @param {object | null | undefined} player
 * @param {string} [displayNameHint]
 */
export function profileBootstrapPatch(player, displayNameHint) {
  const defaults = defaultPlayerProfileFields();
  /** @type {Record<string, unknown>} */
  const patch = {};
  for (const [key, value] of Object.entries(defaults)) {
    if (player?.[key] === undefined) patch[key] = value;
  }
  const name = String(player?.displayName || displayNameHint || "").trim();
  if (name && !String(player?.displayName || "").trim()) patch.displayName = name;
  return patch;
}

export function defaultPlayerProfileFields() {
  return {
    profileVersion: PROFILE_VERSION,
    profilePhoto: null,
    coverPhoto: null,
    gender: null,
    dateOfBirth: null,
    preferredHand: "",
    playingCategory: "All",
    firstName: null,
    lastName: null,
    city: null,
    state: null,
    country: null,
    countryIso: null,
    club: null,
    preferredEvents: [],
    contactEmail: null,
    phoneCountryIso: null,
    phoneDialCode: null,
    phoneNationalNumber: null,
    bio: null,
    favoriteShot: null,
    yearsPlaying: null,
    isProfilePublic: true,
    profileCompletedPercentage: 0,
    profileExtensions: {},
  };
}
